import * as ACTION_TYPES from './types';

export function conversationActive(groupId, isExpand = false) {
  return {
    type: ACTION_TYPES.CONVERSATION_ACTIVE_CONVERSATION,
    payload: {
      groupId,
      isExpand,
    },
  };
}

export function clearConversationActive() {
  return {
    type: ACTION_TYPES.CONVERSATION_ACTIVE_CLEAR_CONVERSATION,
    payload: {},
  };
}
